import { ClienteListItemModel } from "./cliente-list-item.model";
export class OverlapCheckElement {
    lat:number;
    lng:number;
    clienti:ClienteListItemModel[]=[];
}

export class OverlappingCheckModel {
    elements:OverlapCheckElement[]=[];
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/clienti/overlappingCheckModel.ts